import React from 'react';
import Banner from './Banner';
import FeatureOne from './FeatureOne';
import ScheduleThree from './ScheduleThree';
import TeamOne from './TeamOne';
import BuyTicket from './BuyTicket';
import TicketOne from './TicketOne';
import Brand from './Brand';
import CTAOne from './CTAOne';


const HomeThreeMain = () => {
	return (
		<>
			<Banner />
			<FeatureOne />
			<ScheduleThree />
			<TeamOne />
			<BuyTicket />
			<TicketOne />
			<Brand />
			<CTAOne />
		</>
	);
}

export default HomeThreeMain;
